import { logWrapper } from '../utils';

function focusMeDirectiveFactory(runtimeConstant, $timeout) {
  function link(scope, element) {
    scope.$watch('trigger', (value) => {
      if (value === 'true') {
        $timeout(() => {
          element[0].focus();
        });
      }
    });
  }

  function run() {
    return {
      scope: {
        trigger: '@focusMe',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const focusMeDirective = ['runtimeConstant', '$timeout', focusMeDirectiveFactory];
